<div class="info-container" [ngClass]="{ 'info-container-embedded': embedded }">
  <!-- Spine img and info -->
  <section class="info-wrapper">
    @if (asset?.bookImage && !isMath(asset.subjectId)) {
      <div
        class="image-wrapper"
        >
        <img
          class="spine-img"
          [src]="getSpineImage()"
          alt="{{ asset?.bookName }} image"
          />
      </div>
    }
    @if (!asset?.bookImage) {
      <div class="no-image-placeholder">
        <span>No Image Available</span>
      </div>
    }

    <div class="info">
      @if (asset?.subjectId) {
        <div>
          <p class="info__header">Program</p>
          <p class="info__text">
            {{ getProgramName() }}
          </p>
        </div>
      }

      @if (asset?.bookActivityType) {
        <div>
          <p class="info__header">Activity Type</p>
          <p class="info__text">
            {{ getDiscoverActivityTypeName(asset?.bookActivityType) }}
          </p>
        </div>
      }

      @if (asset?.levelIds) {
        <div class="list" fxLayout="row wrap">
          <div class="list__item">
            <p class="info__header">Level</p>
            <p class="info__text">
              {{ getLevel(asset?.levelIds) }}
            </p>
          </div>
          @if (!isMath(asset?.subjectId)) {
            <div class="list__item">
              <p class="info__header">Unit</p>
              <p class="info__text">
                {{ asset.unit ? asset.unit : "---" }}
              </p>
            </div>
          }
          @if (!isMath(asset?.subjectId)) {
            <div class="list__item">
              <p class="info__header">Lesson</p>
              <p class="info__text">
                {{ asset.lesson ? asset.lesson : "---" }}
              </p>
            </div>
          }
          @if (!isMath(asset?.subjectId)) {
            <div class="list__item">
              <p class="info__header">Page</p>
              <p class="info__text">
                {{ asset.page ? asset.page : "---" }}
              </p>
            </div>
          }
          <!-- Activity Number -->
          @if (
            asset?.assetTypeId === assetTypeIds.EBOOK_ACT ||
            asset?.assetTypeId === assetTypeIds.EREADER ||
            asset?.assetTypeId === assetTypeIds.CUSTOM_ACT
            ) {
            <div
              class="list__item"
              >
              <p class="info__header">Activity Number</p>
              <p class="info__text">
                {{ getActivityNumber(asset) }}
              </p>
            </div>
          }
        </div>
      }
    </div>
  </section>

  <!-- Directions and Preview -->
  <section
    class="notes-container"
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center start"
    fxLayoutGap="30px"
    >
    <div class="preview">
      <button
        mat-raised-button
        color="primary"
        (click)="previewActivity(asset)"
        >
        Preview Activity
      </button>
    </div>
  </section>
</div>
